import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { articlePicker_template } from "../components/templates/articlePicker_template";
import { UploadStatusHandler } from "../utils/UploadStatusHandler";
import { HYPERLINK_DATA_FIELDS } from "../utils/consts/hyperlink_data_fields";
declare var ko: any;

export class articlePicker_helper {

  protected XHRHdls: XMLHttpRequestHandler[] = [];
  protected articlePicker: articlePicker_template;
  private vnAppZone: any;
  private callerModule: any;
  public uploadStatus: UploadStatusHandler = new UploadStatusHandler();
  protected progressBar: HTMLProgressElement;
  protected uploadProgress: any;
  private static readonly articleCompleted: number = 6;

  constructor(articlePicker: articlePicker_template, vnAppZone: any, callerModule: any){
    this.articlePicker = articlePicker;
    this.vnAppZone = vnAppZone;
    this.callerModule = callerModule;
  }

  protected getArticleReferences(){


    if(typeof this.callerModule.getArticleReferences === 'function'){
      return;
    }

    if (this.XHRHdls['getArticleReferences']) {

      this.XHRHdls['getArticleReferences'].cancelAndReset();
    }
    let brand = this.vnAppZone.app.params.idBrand;
    if(!brand){
      brand = this.callerModule.getBrandId();
    }
    let usrReq_url: string = '/api/brand/' + brand + '/articles/references';
    let usrReq_params: Array<Array<string>> = [];

    this.XHRHdls['getArticleReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdls['getArticleReferences'].onReadyStateFunction = this.onReferenceRequestReturn;
    this.XHRHdls['getArticleReferences'].execute();
  }

  protected onReferenceRequestReturn(req, obj){

    return function () {
        obj.callerModule.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            obj.articlePicker.setNetworkCategoryFilterItems(responseParsed.groupCategory);
            obj.articlePicker.setContentTypeFilterItems(responseParsed.contentType);
            obj.articlePicker.setCategoryFilterItems(responseParsed.categories);
            obj.articlePicker.setClassificationFilterItems(responseParsed.classification);
            obj.articlePicker.setIntentFilterItems(responseParsed.intent || []);
        });

    }
  }

  protected getArticleReportList(){

    // LOADING : starts
    this.articlePicker.showLoading();

    if (this.XHRHdls['getArticleReportList']) {

      this.XHRHdls['getArticleReportList'].cancelAndReset();
    }
    let brand = this.vnAppZone.app.params.idBrand;
    if(!brand){
      brand = this.callerModule.getBrandId();
    }
    let usrReq_url: string = '/api/brand/' + brand + '/articles/getArticleReport/';
    let vm = this.articlePicker.getViewModelForRequest();
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(['data', ko.toJSON(vm)]);
    usrReq_params.push(['isPicker', 'true']);
    usrReq_params.push(['articleStatuses', JSON.stringify([articlePicker_helper.articleCompleted])]);

    this.XHRHdls['getArticleReportList'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
    this.XHRHdls['getArticleReportList'].onReadyStateFunction = this.onFilterRequestReturn;
    this.XHRHdls['getArticleReportList'].execute();
  }

  protected onFilterRequestReturn(req, obj){

    return function(){
        obj.callerModule.manageResponse(req, obj, function(){

            let responseParsed = JSON.parse(req.request.response);
            obj.updateList(responseParsed);
            obj.articlePicker.hideLoading();
        });
    }
  }

  protected searchRelatedVectorArticles(target = null){

    if(typeof this.callerModule.getEditorContent !== 'function' || typeof this.callerModule.getArticleId !== 'function'){
      return;
    }
    let content = null;
    let idArticle = this.callerModule.getArticleId();

    if(target) {
      content = this.callerModule.getEditorContent(target);
    }

    let keyword = this.articlePicker.getKeyword();

    if(content || keyword){
      // LOADING : starts
      this.articlePicker.showRelatedLoading();
      document.getElementById("show-more-btn").classList.add("is-disable");
      document.getElementById("related-article-results-list").classList.remove("is-hidden");

      if (this.XHRHdls['getRelatedArticleList']) {

        this.XHRHdls['getRelatedArticleList'].cancelAndReset();
      }
      let brand = this.vnAppZone.app.params.idBrand;
      if(!brand){
        brand = this.callerModule.getBrandId();
      }
      let usrReq_url: string = '/api/brand/' + brand + '/sensai/related_article_vector_search/';
      let usrReq_params: Array<Array<string>> = [];
      if(content){
        usrReq_params.push(['content', content]);
      }
      if(keyword){
        usrReq_params.push(['keyword', keyword]);
      }
      if(idArticle){
        usrReq_params.push(['idArticle', idArticle]);
      }

      this.XHRHdls['getRelatedArticleList'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdls['getRelatedArticleList'].mode = XMLHttpRequestHandler_requestType.POST;
      this.XHRHdls['getRelatedArticleList'].onReadyStateFunction = this.onVectorSearchRequestReturn;
      this.XHRHdls['getRelatedArticleList'].execute();
    }

  }

  protected onVectorSearchRequestReturn(req, obj){

    return function(){
        obj.callerModule.manageResponse(req, obj, function(){

            let responseParsed = JSON.parse(req.request.response);
            obj.updateRelatedArticleList(responseParsed);
            obj.articlePicker.hideRelatedLoading();
        });
    }
  }

  protected updateRelatedArticleList(responseParsed: any) {

    this.articlePicker.setRelatedArticles(responseParsed.results);
  }

  protected updateList(responseParsed: any) {

    this.articlePicker.setArticlePagination(responseParsed.reportData.totalPage, responseParsed.reportData.currentPage);
    this.articlePicker.setArticles(responseParsed.reportData.data);
  }

  protected filterSimpleCancel() {

  }

  protected filterSimpleOnChange(idElement) {

    this.articlePicker.resetPagination();
    this.getArticleReportList();
    this.searchRelatedVectorArticles();
  }

  protected filterMultipleSelectorOnChange(){
    this.articlePicker.resetPagination();
    this.getArticleReportList();
  }

  protected getArticleById(id, isQuickInsert = false){

      if (this.XHRHdls['getArticleById']) {

        this.XHRHdls['getArticleById'].cancelAndReset();
      }

      let brand = this.vnAppZone.app.params.idBrand;
      if(!brand){
        brand = this.callerModule.getBrandId();
      }

      let usrReq_url: string = '/api/brand/' + brand + '/articles/get/' + id + '?allowAll=true';
      let usrReq_params: Array<Array<string>> = [];

      this.XHRHdls['getArticleById'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdls['getArticleById'].onReadyStateFunction = isQuickInsert ? this.onByIDRequestReturnQuickInsert : this.onByIdRequestReturn;
      this.XHRHdls['getArticleById'].execute();
  }

  protected onByIdRequestReturn(req, obj){

      return function () {
          obj.callerModule.manageResponse(req, obj, function () {

              let responseParsed = JSON.parse(req.request.response);
              obj.setArticleData(responseParsed.data.article);
          })
      }
  }

  protected setArticleData(article){
    this.articlePicker.articlePickerView.setArticleData(article);
    this.articlePicker.hideFullLoading();
    this.articlePicker.articlePickerView.hideLoading();
  }

  protected onByIDRequestReturnQuickInsert(req, obj){

    return function () {
        obj.callerModule.manageResponse(req, obj, function () {
            let responseParsed = JSON.parse(req.request.response);
            obj.quickInsertArticleData(responseParsed.data.article);
        })
    }
  }

  protected quickInsertArticleData(article) {
    this.articlePicker.articlePickerView.quickInsertArticleHyperlink(article);
  }

  protected showImagePicker(image, mode = ""){
    this.callerModule.showImagePicker(image, mode);
  }

  protected getImage(imgSrc){
    this.callerModule.getImage(imgSrc);
  }

  protected editImage(img){
    this.callerModule.editImage(img);
  }

  protected insertArticleDisplayCardElement(elementToReplace, articleObject){

    let articleElement = this.buildArticleDisplayCardElement(articleObject);
    this.callerModule.insertArticleElement(elementToReplace, articleElement, this.articlePicker.getTarget());
    this.articlePicker.articlePickerView.hide();
    this.articlePicker.hide();
  }

  protected buildArticleDisplayCardElement(article){
    let articleId = article.id;
    let image = article.image;
    let imageOverride = article.imageOverride;
    let viewType = article.viewType;
    let title = article.title;
    let titleOverride = article.titleOverride;
    let excerpt = article.excerpt;
    let excerptOverride = article.excerptOverride;
    let label = article.label;

    //viewType
    let viewTypeElement = '<div data-field="view-type" style="visibility: hidden">' + viewType + '</div>';

    //label
    let labelElement = '';
    if(label != null) {
      labelElement = '<div class="heading-desc" data-field="label">' + label + '</div>';
    }

    //image
    let imageElement = '';
    if(image != null && viewType != "hide"){
        imageElement = '<div class="w-img"><img data-image-id="'+ image["id"] +'" data-field="image" src="' + image["url"] + '" alt="' + image["altText"] + '" width="' + image["width"] + '" height="' + image["height"] + '" /></div>';
    }
    if(imageOverride != null && viewType != "hide"){
        imageElement = '<div class="w-img"><img data-image-id="'+ image["id"] +'" data-field="image-override" src="' + imageOverride["url"] + '" alt="' + imageOverride["altText"] + '" width="' + imageOverride["width"] + '" height="' + imageOverride["height"] + '" /></div>';
    }

    //title
    let titleElement =  '';
    if(title != null){
      titleElement = '<h3 data-field="title">' + title + '</h3>';
    }
    if(titleOverride != null){
      titleElement = '<h3 data-field="title-override">' + titleOverride + '</h3>';
    }

    //excerpt
    let excerptElement = '';
    if(excerpt != null){
      excerptElement = '<div data-field="excerpt">' + excerpt + '</div>';
    }
    if(excerptOverride != null){
      excerptElement = '<div data-field="excerpt-override">' + excerptOverride + '</div>';
    }

    //build the full element
    let articleElement = '<div class="emaki-displayCard article" contenteditable="false" data-id="' + articleId + '">'
    +'<div class="heading">'
    + viewTypeElement
    + labelElement
    + titleElement
    + excerptElement
    + '</div><div class="w-img-info">'
    + imageElement
    + '</div></div>';

    return articleElement;
  }

  protected getArticleInsertedItems(articleHtml){

    //id
    let id = articleHtml.getAttribute('data-id');

    // image
    let imageOverride: {
      id: string | null;
      url: string | null;
      altText: string | null;
      width: string | null;
      height: string | null;
    } | null = null;
    if(articleHtml.querySelector('[data-field="image-override"]') != null){
      imageOverride = {
        id: articleHtml.querySelector('[data-field="image-override"]').getAttribute('data-image-id'),
        url: articleHtml.querySelector('[data-field="image-override"]').getAttribute('src'),
        altText: articleHtml.querySelector('[data-field="image-override"]').getAttribute('alt'),
        width: articleHtml.querySelector('[data-field="image-override"]').getAttribute('width'),
        height: articleHtml.querySelector('[data-field="image-override"]').getAttribute('height')
      };
    }

    // title
    let titleOverride = null;
    if(articleHtml.querySelector('[data-field="title-override"]') != null){
      titleOverride = articleHtml.querySelector('[data-field="title-override"]').innerHTML;
    }

    // excerpt
    let excerptOverride = null;
    if(articleHtml.querySelector('[data-field="excerpt-override"]') != null){
      excerptOverride = articleHtml.querySelector('[data-field="excerpt-override"]').innerHTML;
    }

    //label
    let label = null;
    if(articleHtml.querySelector('[data-field="label"]') != null){
      label = articleHtml.querySelector('[data-field="label"]').innerHTML;
    }

    let viewType = 'small';
    if(articleHtml.querySelector('[data-field="view-type"]') != null){
      viewType = articleHtml.querySelector('[data-field="view-type"]').innerHTML;
    }

    let permalink = null;

    const isHyperlink = articleHtml.classList.contains('hyperlink');
    if(isHyperlink){
      titleOverride = articleHtml.getAttribute(HYPERLINK_DATA_FIELDS.IS_TITLE_OVERRIDE) ? articleHtml.innerHTML : null;
      permalink = articleHtml.getAttribute(HYPERLINK_DATA_FIELDS.PERMALINK);
    }

    let insertedElements = {
      idArticle: id,
      imageOverride: imageOverride,
      viewType: viewType,
      titleOverride: titleOverride,
      excerptOverride: excerptOverride,
      label: label,
      permalink: permalink,
      isHyperlink: isHyperlink,
    };

    return insertedElements;
  }

  protected cancelAndResetFetchRequest(requestName){

    if (this.XHRHdls[requestName]) {

      this.XHRHdls[requestName].cancelAndReset();
    }
  }

  public filterDropdownOnChange() {
    this.articlePicker.resetPagination();
    this.getArticleReportList();
  }

  protected getTagsSuggestion(keyword, idElement) {

    if( this.XHRHdls['getTagsSuggestion'] ){
        this.XHRHdls["getTagsSuggestion"].cancelAndReset();
    }

    let subViewModel = {filter: {keyword: keyword}, idElement: idElement};
    let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/search/tag/";
    let usrReq_params: Array<Array<string>> = [];
    usrReq_params.push(["data", ko.toJSON(subViewModel)]);
    this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

    this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
    this.XHRHdls['getTagsSuggestion'].execute();
}

  protected onGetTagsSuggestionReturn(req, obj) {

    return function () {
        obj.callerModule.manageResponse(req, obj, function () {

            let responseParsed = JSON.parse(req.request.response);
            if (responseParsed.data.tags) {
                obj.articlePicker.setTagFilter(responseParsed.data.tags);
            }

        });
    }
  }

  protected insertArticleHyperlinkElement(elementToReplace, articleObject) {

    let articleElement = this.buildArticleHyperlinkElement(articleObject);
    this.callerModule.insertArticleElement(elementToReplace, articleElement, this.articlePicker.getTarget());
    this.articlePicker.articlePickerView.hide();
    this.articlePicker.hide();
  }

  protected buildArticleHyperlinkElement(article) {

    const articleId = article.id;
    const articlePermalink = article.permalink;
    const hyperlinkText = article.titleOverride ? article.titleOverride : article.title;
    const hyperlinkType = article.hyperlinkType;

    const idProp = !!articleId ? `${HYPERLINK_DATA_FIELDS.ID}="${articleId}"` : '';
    let isTitleOverrideProp = !!article.titleOverride ? `${HYPERLINK_DATA_FIELDS.IS_TITLE_OVERRIDE}="true"` : '';
    const permalinkProp = !!articlePermalink ? `${HYPERLINK_DATA_FIELDS.PERMALINK}="${articlePermalink}"` : '';
    const hyperlinkTypeProp = !!hyperlinkType ? `${HYPERLINK_DATA_FIELDS.HYPERLINK_TYPE}="${hyperlinkType}"` : '';

    const hyperlinkPropArray = [
      idProp,
      isTitleOverrideProp,
      permalinkProp,
      hyperlinkTypeProp
    ]

    let hyperlinkProps = hyperlinkPropArray.filter(s => s != '').join(' ');

    const articleElement = `<span class="emaki-displayCard hyperlink-article hyperlink" contenteditable="false" ${hyperlinkProps}>${hyperlinkText}</span>`


    return articleElement;
  }

  protected viewArticleOnSite(brand, permalink) {

    let origin = document.location.origin;
    let brandDomain = brand.domain;
    if (!origin.includes("https://emakicms.com")) {
      brandDomain = brandDomain.replace("www.", "");
    }
    let url = origin.replace("emakicms.com", brandDomain) + permalink;

    if (url.includes("mig1")) {
      url = url.replace("mig1", "qa2");
    }

    if (url.includes("mig2")) {
      url = url.replace("mig2", "qa1");
    }

    if (url.includes("mig3")) {
      url = url.replace("mig3", "qa3");
    }

    if (url.includes("mig4")) {
      url = url.replace("mig4", "qa1");
    }

    let element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('target', '_blank');
    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected quickInsertArticleHyperlink(articleData) {

    this.getArticleById(articleData.id, true);
  }
}


// WEBPACK FOOTER //
// ./js/modules/articlePicker_helper.ts